import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
// slices
import notificationReducer from './slices/notification';
import authReducer from './slices/auth';
import kanbanDeliveries from './slices/retailer/kanbanDeliveries';
import weeklyHQPackageOverview from './slices/retailer/weeklyHQPackageOverview';
import monthlyDeliveriesMetrics from './slices/retailer/monthlyDeliveriesMetrics';
import customerDeliveries from './slices/retailer/customerDeliveries';
import users from './slices/users';
import retailerDashboardMetrics from './slices/retailer/retailerDashboardMetrics';
import retailerHQSuppliers from './slices/retailer/retailerHQSuppliers';
import shippers from './slices/retailer/retailerShippers';
import retailerOutlets from './slices/retailer/retailerOutlets';

const rootPersistConfig = {
  key: 'root',
  storage,
  keyPrefix: 'redux-',
  whitelist: [],
};

const notificationPersistConfig = {
  key: 'notification',
  storage,
  keyPrefix: 'redux-',
};

const rootReducer = combineReducers({
  auth: authReducer,
  notification: persistReducer(notificationPersistConfig, notificationReducer),
  kanbanDeliveries: kanbanDeliveries,
  weeklyHQPackageOverview: weeklyHQPackageOverview,
  monthlyDeliveriesMetrics: monthlyDeliveriesMetrics,
  customerDeliveries: customerDeliveries,
  retailerDashboardMetrics: retailerDashboardMetrics,
  retailerHQSuppliers: retailerHQSuppliers,
  shippers: shippers,
  retailerOutlets: retailerOutlets,
  users,
});

export { rootPersistConfig, rootReducer };
